import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import "./index.scss";
import { SuccessLogo, SuccessLogoSM } from "../../assets/images/svg/svg";
import {
  buyNow,
  orders,
  ordersDetails,
  orderSummary,
  paymentSummary,
} from "../../utils/router/constant";
import Button from "../common/button";
import { useLocation, useNavigate } from "react-router-dom";
import MainLayout from "../../layout/mainLayout";
import {
  formatDate,
  formatDateTime,
  formatPaymentMode,
  getParamsFromURL,
  setParamsInURL,
} from "../../utils/helper";
import { readData } from "../../service/order/orderService";
import { useSelector } from "react-redux";
import { createForm, updateForm } from "../../service/proposal/proposalService";
import { FG_PRODUCT_IDS, isFgProduct } from "../../utils/commonConstant";

const Success = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [orderId, setOrderId] = useState(null);
  const nav = useNavigate();
  const [entityid, setEntityId] = useState(null);
  const [isFgOrder, setIsFgOrder] = useState(false);
  const [showFgModal, setShowFgModal] = useState(false);
  const detailsData = useSelector(
    (state) => state.orders.selectedOrder.detailsData
  );

  console.log("detailsData", detailsData)
  const productAttributes = useSelector(
    (state) => state.product.productAttributes
  );

  const data = useSelector((state) => state.orders.selectedOrder.detailsData);
  const productType = data.product_type_name;

  // Set when /payment-processing hands us the polled PaymentData directly,
  // instead of the legacy encrypted `code` param.
  const routeState = location.state;

  useEffect(() => {
    if (routeState) return;

    const fetchCode = async () => {
      await getParamsFromURL(location).then((params) => {
        if (params) {
          setOrderId(params["orderId"]);
          setEntityId(params["entityid"]);
        } else {
          console.error("No parameters found");
        }
      });
    };
    fetchCode();
  }, [location, routeState]);

  useEffect(() => {
    // parentId comes from /payment/status and is the ODR entity id. Never use
    // routeState.orderId here — that is the gateway's string id (ODRI1XXD…)
    // and /entity/read answers 400 for it.
    const id = orderId || routeState?.parentId;

    // [FG] debug
    console.log("[FG] success page resolving order id:", {
      id,
      source: orderId ? "url param" : routeState?.parentId ? "routeState.parentId" : "NONE",
      hasRouteState: !!routeState,
    });

    if (!id) {
      // Only a real problem once routeState is here without a parentId; on the
      // legacy `code` route this effect just runs early, before params resolve.
      if (routeState) {
        console.warn(
          "[FG] routeState has no parentId - /entity/read skipped, modal cannot show",
        );
      }
      return;
    }

    readData(id, "ODR")
      .then((order) => {
        // A 403 does NOT reject: the interceptor in utils/interface.js swallows
        // it with Promise.resolve() and redirects to login, so `order` lands
        // here as undefined rather than in .catch below.
        if (!order) {
          console.warn(
            "[FG] /entity/read returned no data (likely 403 -> redirected to login)",
          );
          return;
        }

        const fg = isFgProduct(order.product_id);
        // [FG] debug
        console.log("[FG] /entity/read ->", {
          product_id: order.product_id,
          FG_PRODUCT_IDS,
          isFgOrder: fg,
          orderCode: order.code,
        });
        setIsFgOrder(fg);
      })
      .catch((err) => {
        console.error("[FG] /entity/read FAILED for id", id, err?.response?.status, err);
      });
  }, [orderId, routeState]);

  useEffect(() => {
    if (orderId && detailsData && detailsData?.renewal_status) {
      const entity = {
        status: detailsData.status,
        variant_json: detailsData.current_variant_json,
      };
    }
  }, [orderId, detailsData]);

  const parsedResponse = JSON.parse(
    detailsData?.payment_data?.payment_response || "{}"
  );

  const paymentTime = parsedResponse?.data?.payment?.payment_time ??
    parsedResponse?.payment_time ??
    parsedResponse?.payment_completion_time ??
    detailsData?.payment_data?.payment_date;

  const paymentResponse = {
    cf_payment_id: parsedResponse?.data?.payment?.cf_payment_id ??
      parsedResponse?.cf_payment_id ??
      detailsData?.payment_data?.txn_id,
    order_id: parsedResponse?.data?.order?.order_id ??
      parsedResponse?.order_id ??
      detailsData?.payment_data?.order_id,
    payment_amount: parsedResponse?.data?.payment?.payment_amount ??
      parsedResponse?.payment_amount ??
      detailsData?.payment_data?.amount,
    payment_group: parsedResponse?.data?.payment?.payment_group ??
      parsedResponse?.payment_group ??
      detailsData?.payment_data?.mode,
    payment_time: paymentTime,
    payment_status: parsedResponse?.data?.payment?.payment_status ??
      parsedResponse?.payment_status ??
      detailsData?.payment_data?.payment_status,
    bank_reference: parsedResponse?.data?.payment?.bank_reference ??
      parsedResponse?.bank_reference ??
      detailsData?.payment_data?.bank_rrn,
  };

  // Arriving from /payment-processing there is no `code` param and no order in
  // the store, so render from the PaymentData the status poll returned.
  const payment = routeState
    ? {
      cf_payment_id: routeState.txnId,
      order_id: routeState.orderId,
      payment_amount: routeState.amount,
      payment_group: routeState.mode,
      payment_time: routeState.paymentDate,
      payment_status: routeState.paymentStatus,
      bank_reference: routeState.bankRrn,
    }
    : paymentResponse;

  const renderInfoBlock = (label, value) => (
    <div className="info-block">
      <div className="label">{label}</div>
      <div className="value">{value || "N/A"}</div>
    </div>
  );

  // const handleContinue = async () => {
  //   const paramObject = {
  //     entityid: entityid,
  //     orderId: orderId,
  //   };

  //   const params = await setParamsInURL(location, paramObject);
  //   if (productType === "UMBRELLA") {
  //     navigate(`${buyNow}?${params}`);
  //   } else {
  //     navigate(`${ordersDetails}?${params}`);
  //   }
  // };

  const leaveReceipt = async () => {
    const activeOrderId = orderId || routeState?.parentId;

    if (!activeOrderId) {
      // [FG] debug
      console.warn("[FG] no order id on Continue - falling back to orders list");
      navigate(orders);
      return;
    }

    const paramObject = {
      entityid: entityid || detailsData?.product_id,
      orderId: activeOrderId,
    };

    // [FG] debug
    console.log("[FG] leaving receipt with params:", paramObject);

    const params = await setParamsInURL(location, paramObject);

    if (detailsData?.payment_data?.return_url) {
      window.location.href = `${detailsData?.payment_data?.return_url}?${params}`;
    } else {
      navigate(`${ordersDetails}?${params}`);
    }
  };

  const handleContinue = () => {
    const fg = isFgOrder || isFgProduct(detailsData?.product_id);
    // [FG] debug
    console.log("[FG] Continue clicked:", {
      isFgOrder,
      "detailsData.product_id": detailsData?.product_id,
      willShowModal: fg,
    });

    if (fg) {
      setShowFgModal(true);
      return;
    }
    leaveReceipt();
  };

  return (
    <div className="status-layout-container">
      <MainLayout>
        <div className="status--container">
          <div className="status--main">
            {/* <div className="status--image success--bg">
            <SuccessLogo />
          </div> */}
            <SuccessLogoSM />
            <div className="status--content">
              <h1 className="status--title success--title">Yay!</h1>
              <h4 className="status--subtitle">Payment successful!</h4>
              <h4 className="status--subtitle">
                Order ID: {detailsData.code || payment.order_id}
              </h4>
              <h4 className="status--subtitle">
                Your acknowledgement is valuable to us!
              </h4>
            </div>
            <div className="payment-info-container mt-4">
              {renderInfoBlock("Transaction ID", payment.cf_payment_id)}
              {renderInfoBlock("Order ID", payment.order_id)}
              {renderInfoBlock(
                "Amount",
                payment.payment_amount != null
                  ? `₹${payment.payment_amount}`
                  : null
              )}
              {renderInfoBlock("Payment Mode", formatPaymentMode(payment.payment_group))}
              {renderInfoBlock("Bank RRN", payment.bank_reference)}
              {renderInfoBlock("Date", formatDate(payment.payment_time))}
              {renderInfoBlock("Status", payment.payment_status)}
            </div>
            <div className="status--footer">
              <Button
                type="button"
                variant="primary"
                label="Continue"
                className={"btn-primary-width"}
                onClick={() => handleContinue()}
              />
            </div>
          </div>
        </div>

        <Modal
          show={showFgModal}
          onHide={() => setShowFgModal(false)}
          centered
          className="policy-issuance-modal"
        >
          <Modal.Header closeButton className="border-0 pb-0" />
          <Modal.Body className="text-center p-4 pt-0">
            <div className="policy-issuance--badge mx-auto mb-3">✓</div>
            <h4 className="policy-issuance--title fw-bold mb-2">Thank you!</h4>
            <p className="text-muted mb-4">
              Your payment was successful. Your policy copy will be generated
              shortly and shared on your registered contact number and email
              address. You can also download it any time from the Documents
              section.
            </p>
            <Button
              type="button"
              variant="primary"
              label="Continue"
              className="btn-primary-width"
              onClick={() => {
                setShowFgModal(false);
                leaveReceipt();
              }}
            />
          </Modal.Body>
        </Modal>
      </MainLayout>
    </div>
  );
};

export default Success;
